import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Text from '../Text';
import { favouriteAdd, favouriteRemove } from '../../redux-root/actions';
import usePrevious from '../../utils/usePrevious';

import styles from "./index.module.css";

import favouriteIcon from "../../assets/icons/favourite/Favorite-default.svg";
import favouritedIcon from "../../assets/icons/favourite/Favorite-selected.svg";
import backIcon from "../../assets/icons/back/back.svg";

const typeList = ["primary", "secondary", "favourite", "back", "icon"];
const apiList = ["movies", "shows", "channels"];

function Button(props) {
  const { text, type, onClick, id, style, textType, image, className, arrow, defaultFav, contentId, contentType, actionResult, selected, tvMode } = props;

  const [favState, setFavState] = useState(defaultFav ? true : false);

  const previousActionResult = usePrevious(actionResult);

  let buttonClass = typeList[0];
  let buttonTextType = textType ? textType : "lb32";
  let textClass = "";
  let crystalEffect = true;

  if (tvMode) {
    crystalEffect = false;
  }

  useEffect(() => {
    if (
      previousActionResult !== actionResult &&
      type === typeList[2] &&
      previousActionResult !== undefined &&
      actionResult !== null &&
      actionResult.id &&
      contentId === actionResult.id.split("/")[1]
    ) {
      if (actionResult.status === false) {
        if (actionResult.addAction) {
          setFavState(false);
        } else {
          setFavState(true);
        }
      }
    }
    /* eslint-disable */
  }, [actionResult]);

  const toggleFavourite = () => {
    const newFavState = !favState;

    let apiType = apiList[0];

    if (contentType.includes("Show")) {
      apiType = apiList[1];
    } else if (contentType.includes("Channel")) {
      apiType = apiList[2];
    }

    if (newFavState) {
      props.favouriteAdd(`${apiType}/${contentId}`);
    } else {
      props.favouriteRemove(`${apiType}/${contentId}`);
    }

    setFavState(newFavState);
  };

  const backClick = () => {
    props.onClick();
  };

  if (typeList.includes(type) && type !== typeList[0]) {
    buttonClass = type;
    buttonTextType = "lb24";
    textClass = "highlight-grey";

    if (type === typeList[1]) {
      crystalEffect = false;

      if (textType) {
        buttonTextType = textType;
      }
    }
  }

  if (buttonClass === typeList[2]) {
    return (
      <button
        className={`${styles["button"]} ${styles[buttonClass]} ${styles[buttonClass]} ${ crystalEffect ? styles['crystal'] : "" } ${ tvMode ? styles['button-focus'] : "" } ${className}`}
        onClick={() => {
          toggleFavourite();

          if (onClick) {
            onClick();
          }
        }}
        id={id}
        style={style}
      >
        <img
          src={favState ? favouritedIcon : favouriteIcon}
          alt="favourite-icon"
        />
      </button>
    );
  } else if (buttonClass === typeList[3]) {
    return (
      <button
        className={`${styles["button"]} ${styles[buttonClass]} ${ crystalEffect ? styles['crystal'] : "" } ${ tvMode ? styles['button-focus'] : "" } ${styles[buttonClass]}`}
        onClick={backClick}
        id={id}
        style={style}
      >
        <img src={backIcon} alt="back-icon" />
      </button>
    );
  } else if (buttonClass === typeList[4]) {
    return (
      <button
        className={`${styles["button"]} ${styles[buttonClass]} ${styles[buttonClass]} ${ crystalEffect ? styles['crystal'] : "" } ${ tvMode ? styles['button-focus'] : "" } ${className}`}
        onClick={onClick}
        id={id}
        style={style}
      >
        <img src={image} alt="icon" />
      </button>
    );
  }

  return (
    <button
      className={`${styles["button"]} ${styles[buttonClass]} ${ crystalEffect ? styles['crystal'] : "" } ${className} ${ selected ? styles['selected'] : "" } ${ tvMode ? styles['button-focus'] : "" }`}
      onClick={onClick}
      id={id}
      style={style}
    >
      {image ? (
        <img
          src={image}
          className={`${text ? styles["img-text"] : ""}`}
          alt="button-img"
        />
      ) : (
        ""
      )}

      {text ? (
        <Text type={buttonTextType} className={styles[textClass]}>
          {text}
        </Text>
      ) : (
        ""
      )}

      {arrow ? (
        <img src={arrow} className={styles["arrow"]} alt="arrow-img" />
      ) : (
        ""
      )}
    </button>
  );
}

const mapStateToProps = (state) => ({
  actionResult: state.favourite.actionResult,
  tvMode: state.app.tvMode
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      favouriteAdd,
      favouriteRemove
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Button);
